import { jsx as e, jsxs as n, Fragment as l } from "react/jsx-runtime";
import { AccordionItem as s, AccordionButton as d } from "@chakra-ui/react";
import { useAccordionVariant as p } from "./accordion-context.js";
import { Icon as f } from "../icon/icon.js";
import { Icons as r } from "../icon/types.js";
import { ThemeIconSizeVariable as I } from "../../theme/theme-types.js";
const g = ({ children: i, title: c, ...t }) => {
  const m = p(), a = (o) => m === "noBorder" ? o ? r.TreeViewCollapse : r.TreeViewExpand : o ? r.Collapse : r.Expand;
  return /* @__PURE__ */ e(s, { ...t, children: ({ isExpanded: o }) => /* @__PURE__ */ n(l, { children: [
    /* @__PURE__ */ e("h3", { children: /* @__PURE__ */ n(d, { children: [
      c,
      /* @__PURE__ */ e(f, { icon: a(o), size: I.Small })
    ] }) }),
    i
  ] }) });
};
export {
  g as AccordionItem
};
